export const app_types = {
    "Internal": 0,
    "Brand": 1,
    "Broker": 2,
}

export const errorMsg = {
    "unverifiedUser": "You can not perform this operation as your account is unverified",
}